module.exports = "/global_cta-403172ad94440950831bc62d431139c0.svg";